import angular from 'angular';

export const tabRightClick = function ($parse) {
    return function (scope, element, attrs) {
        const fn = $parse(attrs.tabRightClick);
        element.bind('contextmenu', (event) => {
            scope.$apply(() => {
                fn(scope, { $event: event });
            });
        });
    };
};

angular
    .module('TALENYA-FE')
    .directive('tabRightClick', tabRightClick);
